import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/blog/BlogFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/blog/BlogNavbar.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
